import { render, staticRenderFns } from "./wx-file.vue?vue&type=template&id=cad8d562&scoped=true&"
import script from "./wx-file.vue?vue&type=script&lang=js&"
export * from "./wx-file.vue?vue&type=script&lang=js&"
import style0 from "./wx-file.vue?vue&type=style&index=0&id=cad8d562&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad8d562",
  null
  
)

export default component.exports